import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/reserved-compute/$marketView")({
  beforeLoad: ({ params }) => {
    if (!["request", "requests"].includes(params.marketView)) throw redirect({ to: "/reserved-compute", replace: true });
  },
  component: () => null,
});
